export let searchRules = {}

export let formRules = {}



// WEBPACK FOOTER //
// ./src/views/customer-task/customer-task.rules.js